import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.lastSupplierId = null
    this.setupSupplierListeners()
    this.setupTurboListeners()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupSupplierListeners() {
    this.element.addEventListener('change', (event) => {
      if (event.target.name && event.target.name.includes('[supplier_id]')) {
        this.lastSupplierId = event.target.value
      }
    })
  }

  setupTurboListeners() {
    document.addEventListener('turbo:before-stream-render', () => {
      this.applyLastSupplierToNewItems()
    })

    const turboFrame = document.getElementById('product_delivery_items')
    if (turboFrame) {
      this.observer = new MutationObserver(() => {
        this.applyLastSupplierToNewItems()
      })

      this.observer.observe(turboFrame, {
        childList: true,
        subtree: true
      })
    }
  }

  applyLastSupplierToNewItems() {
    if (!this.lastSupplierId) return

    setTimeout(() => {
      const supplierSelects = this.element.querySelectorAll('select[name*="[supplier_id]"]')

      supplierSelects.forEach(select => {
        this.setSupplierValue(select)
      })
    }, 200)
  }

  setSupplierValue(select) {
    if (select.value !== this.lastSupplierId) {
      if ($(select).hasClass('select2-hidden-accessible') || $(select).data('select2')) {
        $(select).val(this.lastSupplierId).trigger('change')
      } else {
        select.value = this.lastSupplierId
        select.dispatchEvent(new Event('change', { bubbles: true }))
      }
    }
  }
}
